
import { fetchSinToken } from "../helpers/fetch";
import { types } from "../types/types";

export const startLoadingProjects = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchSinToken('projects',{},'GET');
            const body = await resp.json();
            const projects = body.projects;
            dispatch(projectsLoaded(projects))
        } catch (error) {

        }
    }
}


const projectsLoaded = (projects = []) => ({
    type: types.projectsLoaded,
    payload: projects
})